const _clientConfig = [];
_clientConfig['dev'] = {
  'client_id': '2r5u72q3m3gh4p78c276qoh741',
  'identity_pool_id': 'us-east-1:82d65f8f-641f-46e2-b7c3-5f223bf621ab',
  'region': 'us-east-1',
  'user_pool_id': 'us-east-1_XO5MyWvab',
  'api_url': 'https://kwxodunllb.execute-api.us-east-1.amazonaws.com/dev',
  's3_region': 'us-east-1',
  'bucket': 'otaglobal-ota-files-dev-us-east-1-bucket'
};
_clientConfig['stg'] = {
  'client_id': '',
  'identity_pool_id': '',
  'region': 'us-east-1',
  'user_pool_id': '',
  'api_url': '',
  's3_region': 'us-east-1',
  'bucket': 'otaglobal-ota-files-stg-us-east-1-bucket'
};
_clientConfig['prd'] = {
  'client_id': '',
  'identity_pool_id': '',
  'region': 'us-east-1',
  'user_pool_id': '',
  'api_url': '',
  's3_region': 'us-east-1',
  'bucket': 'otaglobal-ota-files-prd-us-east-1-bucket'
};
const clientConfig = _clientConfig[process.env.REACT_APP_PUBLISH_ENV];
export default clientConfig;
